import React, { useState } from 'react';
import { useStore } from '../../store/useStore';
import { MessageCircle, CheckCircle2, XCircle, Link as LinkIcon, Loader2, QrCode } from 'lucide-react';

export function M10_WhatsApp() {
  const { connections, setConnections } = useStore();
  const [isConnecting, setIsConnecting] = useState(false);
  const [showQr, setShowQr] = useState(false);

  const handleConnect = () => {
    setIsConnecting(true);
    setShowQr(true);
    setTimeout(() => {
      setIsConnecting(false);
      setShowQr(false);
      setConnections({ whatsappConnected: true });
    }, 3000);
  };

  const isConnected = connections.whatsappConnected;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight text-gray-900">Integração WhatsApp Business API</h2>
        <p className="text-gray-500 mt-1">
          Escaneie o QR Code para conectar a inteligência diretamente no canal de atendimento do cliente.
        </p>
      </div>

      <div className={`p-8 rounded-xl border-2 transition-all ${isConnected ? 'bg-green-50/50 border-green-200' : 'bg-white border-gray-200'}`}>
         <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <div className={`p-4 rounded-full ${isConnected ? 'bg-green-100' : 'bg-emerald-50'}`}>
                <MessageCircle size={32} className={isConnected ? 'text-green-600' : 'text-emerald-600'} />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900">API WhatsApp</h3>
                <div className="flex items-center gap-2 mt-1">
                  {isConnected ? (
                     <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700">
                        <CheckCircle2 size={14} /> Autenticado (Sessão Ativa)
                     </span>
                  ) : (
                     <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
                        <XCircle size={14} /> Pendente
                     </span>
                  )}
                </div>
              </div>
            </div>

            <div>
              {isConnected ? (
                <button 
                  onClick={() => setConnections({ whatsappConnected: false })}
                  className="px-4 py-2 border border-red-200 text-red-600 rounded-lg hover:bg-red-50 transition-colors text-sm font-medium"
                >
                  Desconectar Sessão
                </button>
              ) : (
                <button 
                  onClick={handleConnect}
                  disabled={isConnecting}
                  className="inline-flex items-center gap-2 px-6 py-3 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors font-medium cursor-pointer disabled:opacity-70 disabled:cursor-not-allowed"
                >
                  {isConnecting ? <Loader2 size={18} className="animate-spin" /> : <QrCode size={18} />}
                  {isConnecting ? 'Aguardando Leitura...' : 'Gerar QR Code de Conexão'}
                </button>
              )}
            </div>
         </div>

         {showQr && !isConnected && (
            <div className="mt-8 pt-8 border-t border-gray-100 flex flex-col items-center justify-center">
                <div className="w-48 h-48 bg-gray-100 rounded-xl animate-pulse flex items-center justify-center">
                   <QrCode className="text-gray-300 w-32 h-32" />
                </div>
                <p className="mt-4 text-sm text-gray-500 font-medium">Abra o WhatsApp no celular e escaneie o código</p>
            </div>
         )}
      </div>
    </div>
  );
}
